import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconView = (props) => {
  props = Object.assign({viewBox: '0 0 32 32'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path
          d="M27.644 26.044l-4.089-4.089c1.511-1.956 2.4-4.267 2.4-6.756 0-2.844-1.156-5.6-3.2-7.644s-4.711-3.2-7.644-3.2c-2.844 0-5.6 1.156-7.644 3.2-4.178 4.178-4.178 11.022 0 15.289 2.133 2.133 4.889 3.111 7.644 3.111 2.4 0 4.8-0.8 6.756-2.4l4.089 4.089 1.689-1.6zM9.156 21.156c-3.289-3.289-3.289-8.711 0-12 1.6-1.6 3.733-2.489 6.044-2.489s4.444 0.889 6.044 2.489c1.6 1.6 2.489 3.733 2.489 6.044s-0.889 4.444-2.489 6.044c-3.378 3.289-8.8 3.289-12.089-0.089z"/>
        <path d="M16.267 10.222h-2.222v3.822h-3.822v2.222h3.822v3.822h2.222v-3.822h3.822v-2.222h-3.822z"/>
      </g>
    </SvgIcon>
  );
};


IconView.displayName = 'IconView';
IconView.muiName = 'SvgIcon';

export default IconView;



// WEBPACK FOOTER //
// ./src/components/Icons/IconView.js